import { filter, keys, length } from "ramda";
import { exists, getSections, isFromGermany } from ".";

export default function enableSubmit(values, availability) {
  if (!exists(values)) {
    return false;
  }

  const valueKeys = ["name", "surname", "email", "time", "policies"];

  // if (length(getSections(availability)) > 1) {
  //   valueKeys.push("section");
  // }

  // if (isFromGermany()) {
  //   const germanValueKeys = [
  //     "covid_positive",
  //     "street",
  //     "zip_code",
  //     "city",
  //     "phone",
  //   ];
  //   valueKeys.push(...germanValueKeys);
  // }

  const hasNotAnsweredFields = filter(
    (vk) => !exists(values[vk]) || values[vk] === false,
    valueKeys
  );

  return length(hasNotAnsweredFields) === 0;
}
